
import { useState, useEffect } from 'react'
import LiscenseCard from './liscense-card'
import { StateSelect } from 'cobra-ui/src/components/Inputs/state-select'
import { States, toTitleCase } from 'cobra-ui/src/utils/states'

interface DisclaimerProps {
  storeState: string
  setDisclaimerOpen: Function
}

const Disclaimer = (props: DisclaimerProps) => {
  const [state, setState] = useState(props.storeState)
  useEffect(() => {
    if (
      !~['ontario', 'british columbia', 'nova scotia'].indexOf(
        state.toLowerCase()
      )
    )
      props.setDisclaimerOpen(false)
  }, [state])

  return (
    <div sx={{ textAlign: 'center' }}>
      <StateSelect
        onChange={setState}
        states={States.canada?.map((s) => s.name) ?? []}
        state={state}
        type={'input'}
        province={true}
        isCashMoney={true}
      />
      <h2
        sx={{
          fontSize: '26px',
          mt: '20px',
          mb: '12px',
          fontFamily: 'heading',
          color: 'brand.red',
          fontWeight: '600',
          textTransform: 'capitalize',
          lineHeight: '1.2',
        }}
      >
        {'Cash Money ' + state + ' License'}
      </h2>
      <p sx={{ mb: '29px' }}>
        {'Cash Money is a licensed lender in ' +
          state +
          '. Please review our sample borrowing costs and our ' +
          state +
          ' license, below.'}
      </p>
      <LiscenseCard state={state} />
      <img
        // class="img-responsive shadowed center-block mb-3"
        sx={{ mt: '20px', mx: 'auto' }}
        src={
          'https://db4nnybic3xty.cloudfront.net/pdf/CM/' +
          toTitleCase(state).replace(' ', '') +
          '.png'
        }
        alt={state + 'License'}
      ></img>
      {state.toLowerCase() != 'british columbia' && (
        <p sx={{ py: '20px' }}>
          For Educational Material about Payday Loans approved by the Registrar,
          please{' '}
          <a
            href={
              state.toLowerCase() == 'ontario'
                ? 'https://secure.cashmoney.ca/Assets/ON_Cost_Comparison_Disclosure_05072019.pdf'
                : state.toLowerCase() == 'nova scotia'
                ? 'https://secure.cashmoney.ca/Assets/NS_Cost_comparison_disclosure_02012019.pdf'
                : '.'
            }
            target="_blank"
            rel="noreferrer noopener"
            sx={{ color: 'brand.red', textDecoration: 'underline' }}
          >
            click here
          </a>
          .
        </p>
      )}
      <button
        onClick={() => props.setDisclaimerOpen(false)}
        sx={{
          variant: 'buttons.primary',
          mb: 5,
          mt: [3, null, null, 1],
        }}
      >
        Next
      </button>
    </div>
  )
}

export default Disclaimer
